import { useCallback } from "react";

import {
    useFireAnalyticsEvents,
    useFastshiftAnalyticsData
} from "@/components/fastshift/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/components/fastshift/analytics/constants";

export const usePageLayoutAnalytics = () => {
    const { sourceKey, identityAttrs } = useFastshiftAnalyticsData(true);
    const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

    const sendSideNavLinkClickEvent = useCallback(
        (
            navLinkTitle: string,
            destinationRoute: string,
            isDomainScopedView: boolean
        ) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.LINK,
                actionSubjectId: ActionSubjectIdKey.SIDE_NAV_LINK,
                source: sourceKey,
                attributes: {
                    navLinkTitle,
                    destinationRoute,
                    isDomainScopedView
                }
            });
        },
        [fireUIEvent, sourceKey]
    );

    const sendCustomerSelectionBackButtonClickEvent = useCallback(
        (destinationRoute: string) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.LINK,
                actionSubjectId:
                    ActionSubjectIdKey.CUSTOMER_SELECTION_BACK_LINK,
                source: sourceKey,
                attributes: {
                    destinationRoute
                }
            });
        },
        [fireUIEvent, sourceKey]
    );

    return {
        sendSideNavLinkClickEvent,
        sendCustomerSelectionBackButtonClickEvent
    };
};
